export const HOME = "home";
export const CONTACT = "contact";
export const WORK = "work";
export const IN_PROCESS = "inProcess";
export const SUCCESS = "success";
export const ERROR = "error";
